import { useEffect, useState } from 'react';
import Header from './components/Header';
import TabBar from './components/TabBar';
import Home from './pages/Home';
import PackOpening from './pages/PackOpening';
import Collection from './pages/Collection';
import Marketplace from './pages/Marketplace';
import Giveaways from './pages/Giveaways';
import { auth } from './api';
import { Tab, User } from './types';

type TgWebApp = {
  ready?: () => void;
  expand?: () => void;
  initDataUnsafe?: {
    user?: { id?: number; username?: string; first_name?: string; last_name?: string };
    start_param?: string;
  };
};

function buildGuestUser(): User {
  const tg = (window as Window & { Telegram?: { WebApp?: TgWebApp } }).Telegram?.WebApp;
  const u = tg?.initDataUnsafe?.user;
  return {
    id: 0,
    tg_id: String(u?.id ?? 0),
    tg_username: u?.username ?? null,
    tg_name: [u?.first_name, u?.last_name].filter(Boolean).join(' ') || 'Guest',
    ton_wallet: null,
    balance_ton: 0,
    created_at: new Date().toISOString(),
  };
}

// Parse deep link: giveaway_123 → { tab: 'giveaways', giveawayId: 123 }
function getStartParam(): { tab: Tab; giveawayId?: number } {
  const tg = (window as Window & { Telegram?: { WebApp?: TgWebApp } }).Telegram?.WebApp;
  const startParam = tg?.initDataUnsafe?.start_param ?? new URLSearchParams(window.location.search).get('giveaway') ?? '';
  if (startParam.startsWith('giveaway_')) {
    const id = parseInt(startParam.replace('giveaway_', ''));
    if (!isNaN(id)) return { tab: 'giveaways', giveawayId: id };
  }
  return { tab: 'home' };
}

export default function App() {
  const startParam = getStartParam();
  const [tab, setTab] = useState<Tab>(startParam.tab);
  const [openGiveawayId, setOpenGiveawayId] = useState<number | undefined>(startParam.giveawayId);
  const [user, setUser] = useState<User>(buildGuestUser);

  useEffect(() => {
    const tg = (window as Window & { Telegram?: { WebApp?: TgWebApp } }).Telegram?.WebApp;
    tg?.ready?.();
    tg?.expand?.();
    auth.login()
      .then((res) => setUser(res.user))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col h-full bg-surface overflow-hidden">
      <Header user={user} />
      <main className="flex-1 overflow-hidden">
        {tab === 'home' && <Home user={user} onTabChange={setTab} />}
        {tab === 'packs' && <PackOpening user={user} />}
        {tab === 'collection' && <Collection user={user} />}
        {tab === 'marketplace' && <Marketplace user={user} />}
        {tab === 'giveaways' && (
          <Giveaways
            user={user}
            deepLinkGiveawayId={openGiveawayId}
            onDeepLinkHandled={() => setOpenGiveawayId(undefined)}
          />
        )}
      </main>
      <TabBar active={tab} onChange={setTab} />
    </div>
  );
}
